'use client';

import React, { useState, ReactNode } from 'react';
import { Layout } from '../../components/Layout';
import { WellnessAddOnsSectionV2 } from './components/WellnessAddOnsSectionV2';
import { WellnessHeroHeaderSectionV2 } from './components/WellnessHeroHeaderSectionV2';
import { WellnessHowItWorksSectionV2 } from './components/WellnessHowItWorksSectionV2';
import { WellnessPlansPageModalV2 } from './components/WellnessPlansPageModalV2';
import { WellnessPlansSectionV2 } from './components/WellnessPlansSectionV2';
import { WellnessFAQSectionV2 } from './components/WellnessFAQSectionV2';
import { WellnessTopHeadingsContainer } from './components/WellnessTopHeadingsContainer';
import { useToggle } from '../../wag-react/common/hooks/useToggle';
export const WellnessPlansPageContainerV2 = () => {
  const {
    on: isModalOpen,
    toggle: toggleModal
  } = useToggle();
  const [modalDetails, setModalDetails] = useState({
    name: '',
    description: null
  });
  const onHelpIconClick = (title: string, description: ReactNode) => {
    setModalDetails({
      name: title,
      description
    });
    toggleModal();
  };
  return <Layout data-sentry-element="Layout" data-sentry-component="WellnessPlansPageContainerV2" data-sentry-source-file="index.tsx">
      <WellnessHeroHeaderSectionV2 data-sentry-element="WellnessHeroHeaderSectionV2" data-sentry-source-file="index.tsx" />

      <WellnessTopHeadingsContainer data-sentry-element="WellnessTopHeadingsContainer" data-sentry-source-file="index.tsx" />

      <WellnessPlansSectionV2 onHelpIconClick={onHelpIconClick} data-sentry-element="WellnessPlansSectionV2" data-sentry-source-file="index.tsx" />
      <WellnessAddOnsSectionV2 onHelpIconClick={onHelpIconClick} data-sentry-element="WellnessAddOnsSectionV2" data-sentry-source-file="index.tsx" />
      <WellnessHowItWorksSectionV2 data-sentry-element="WellnessHowItWorksSectionV2" data-sentry-source-file="index.tsx" />
      <WellnessFAQSectionV2 data-sentry-element="WellnessFAQSectionV2" data-sentry-source-file="index.tsx" />

      <WellnessPlansPageModalV2 isOpen={isModalOpen} value={modalDetails} onRequestClose={toggleModal} data-sentry-element="WellnessPlansPageModalV2" data-sentry-source-file="index.tsx" />
    </Layout>;
};